const LG_BREAKPOINT = 992;
const MD_BREAKPOINT = 768;
const SM_BREAKPOINT = 576;
const XL_BREAKPOINT = 1200;
const XXL_BREAKPOINT = 1400;

export { LG_BREAKPOINT, MD_BREAKPOINT, SM_BREAKPOINT, XL_BREAKPOINT, XXL_BREAKPOINT };
//# sourceMappingURL=breakpoints.js.map
